const TenantPermissions = Object.freeze({
  Home: 0,
  Motor: 1,
});

export default TenantPermissions;
